import { v4 as uuidv4 } from "uuid";

export default {
  ENV: import.meta.env.MODE,
  spreedlyKey:
    import.meta.env.VITE_SPREEDLY_ENVIRONMENT_KEY ||
    "MbskPSZ9MMH7vnuAItHyGdqotHe",
  googleMapsApiKey: import.meta.env.VITE_REACT_APP_GOOGLE_MAPS_API_KEY,
  REACT_APP_VERSION:
    import.meta.env.VITE_REACT_APP_VERSION ?? `local-${uuidv4()}`,
  MOCK: import.meta.env.VITE_MOCK === "true",
  SIFT_ACCOUNT: import.meta.env.VITE_SIFT_ACCOUNT,
  RECAPTCHA_KEY: import.meta.env.VITE_RECAPTCHA_KEY,
  RECAPTCHA_ACTION_KEY: import.meta.env.VITE_RECAPTCHA_ACTION_KEY,
  googleIdentityClientId: import.meta.env.VITE_GOOGLE_IDENTITY_CLIENT_ID,
  ONETRUST_DOMAIN_SCRIPT: import.meta.env.VITE_ONETRUST_DOMAIN_SCRIPT,
};
